import styled from '@emotion/styled';

export interface PlatformIconProps {
  platform: General.CaselessPlatformTunnel;
  iconName?: string;
  size?: number;
}

export const PlatformIcon = (props: PlatformIconProps) => {
  const { platform, iconName, size } = props;
  const filename = iconName || platform.toLowerCase();

  return (
    <ImgIcon
      style={{ width: size, height: size }}
      alt={platform}
      src={`${process.env.PUBLIC_URL}/platform-icons/${filename}.svg`}
    />
  );
};

const ImgIcon = styled.img`
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 0;
  text-align: center;
  vertical-align: -0.125em;
`;
